export default __webpack_public_path__ + "static/stacked-area-55157f24e5e92c1a795e895bbca0f0ff.png";